import { useTranslation } from "next-i18next";
import Icon from "@ui-kit/icons/Icon.web";
import {
  getPriceRange,
  GetPriceRangeOptions,
} from "@shared/modules/financials/utils/price-utils";
import { Badge, ChildBadgeProps } from "@ui-kit/data-display/Badge/Badge";

export interface PriceRangeBadgeProps extends ChildBadgeProps {
  items: GetPriceRangeOptions["items"] | undefined;
  currency: GetPriceRangeOptions["venueCurrency"] | undefined;
  allInPricingIsEnabled: GetPriceRangeOptions["allInPricing"] | undefined;
}

export const PriceRangeBadge = ({
  items,
  isVisible = true,
  currency = "CAD",
  allInPricingIsEnabled = false,
}: PriceRangeBadgeProps) => {
  const { t } = useTranslation("purchases");
  const icon = (
    <Icon.DollarFilled
      boxSize={{ base: "element.md", sm: "element.xl" }}
      mr="sm"
      aria-label={t("dollar icon")}
    />
  );
  const text = getPriceRange({
    items,
    allInPricing: allInPricingIsEnabled,
    venueCurrency: currency,
  });

  return (
    <Badge
      icon={icon}
      text={text}
      isVisible={isVisible && Boolean(items && items.length > 0)}
      data-testid="price-range-badge"
    />
  );
};
